import moment from 'moment';
import {hasMonetaryValue, requiresW9AndAffidavit} from 'pages/EditPrize/utils';

export const needsWinnersManuallySelected = prize => {
  // only raffles with monetary values that legally require W9+affidavit paperwork must
  // have their winners manually selected.
  if (!hasMonetaryValue(prize)
  || (prize.type === "RAFFLE" && !requiresW9AndAffidavit(prize))) {
    return false;
  }

  return prize.numAwardsToSelect > 0;
};



// WEBPACK FOOTER //
// ./public/pages/ListEntries/utils.js